import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import { fireTag } from '../../libs/analytics.js';

import heroImage from '../../images/articles/wf_impact_isf_articles_us-mayors-climate-change_desktop.jpg';
import heroMobileImage from '../../images/articles/wf_impact_isf_articles_us-mayors-climate-change_mobile.jpg';

import ModalOverlay from "../../components/ModalOverlay";

const Mayors = ({
					uiState,
					isMobile,
					handleEvent,
					closeExitOverlay,
					addExitClickListeners,
					displayModalOverlay,
					modalOverlay,
				}) => {

	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	const heroOGImage = 'wf_impact_isf_articles_us-mayors-climate-change_desktop.jpg';

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				fireTag('A1',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}

	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
		linkDisclosures();


	}, []); // empty array says only use this effect once

	let mastheadImage = window.innerWidth < 768 ? heroMobileImage : heroImage;
	// console.log(mastheadImage);
	addExitClickListeners();
	return (
		<>
			<Helmet>
				<title>Wells Fargo joins U.S. mayors to support cities weathering climate change </title>
				<meta
					name="description"
					content="The U.S. Conference of Mayors released a 20-page report, sponsored by Wells Fargo, on climate change-related risks and potential solutions, and how the public and private sectors can work together to tackle these issues. "
				/>
				<meta property="og:title" content="Wells Fargo joins U.S. mayors to support cities weathering climate change"/>
				<meta
					property="og:description"
					content="The U.S. Conference of Mayors released a 20-page report, sponsored by Wells Fargo, on climate change-related risks and potential solutions, and how the public and private sectors can work together to tackle these issues. "
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>

				<meta property="twitter:title" content="Wells Fargo joins U.S. mayors to support cities weathering climate change "/>
				<meta
					property="twitter:description"
					content="The U.S. Conference of Mayors released a 20-page report, sponsored by Wells Fargo, on climate change-related risks and potential solutions, and how the public and private sectors can work together to tackle these issues. "
				/>i
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}
			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>
			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}

			<main className="flex-container">
				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1">
							Wells Fargo joins U.S. mayors to support cities weathering climate change
						</h1>
						<ul className="header-list">
							<li>
								The U.S. Conference of Mayors released a 20-page report, sponsored by Wells Fargo, on climate change-related risks and potential solutions, and how the public and private sectors can work together to tackle these issues.
							</li>
							<li>
								The report provides strategies to help develop more resilient communities that can better adapt to changing climate conditions.
							</li>
						</ul>
					</div>
				</div>
				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="An overhead view of a busy intersection in a large city."/>
					</div>
				</div>




				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro">
						<div className="article-info">
							<div>
								<p>April 5, 2023</p>
							</div>
							<div>
								<p>5-minute read</p>
							</div>
						</div>
						<p>Cities across the U.S. are experiencing a wide range of climate-related challenges, but local leaders cannot respond to these challenges alone. The U.S. Conference of Mayors (USCM) is calling for private sector partnerships and increased funding to effectively manage the rapid changes to environments and communities.</p>
						<p>A 20-page report produced by <a onClick={()=> fireTag("A1","uscm")} target="_blank" href="https://www.usmayors.org/" rel="noreferrer">USCM</a>, sponsored by the Wells Fargo Institute for Sustainable Finance and in collaboration with <a onClick={()=> fireTag("A1","rocky mountain institute")} target="_blank" href="https://rmi.org/" rel="noreferrer">Rocky Mountain Institute</a> (RMI), provides effective options for climate mitigation and climate resilience. Investing in Resilient and Equitable Neighborhoods highlights best practices that can be tailored to meet the demands of each community.
						</p>
					</div>
					<div className="flex-col-md-8 flex-col-sm-12 text-center pullquote-container ">
						<figure className="pullquote">
							<div className="bd-left">

								<blockquote cite="https://www.usmayors.org/wp-content/uploads/2023/01/Wells-Fargo-white-papers-011823_830pm.pdf">
									<p>
										“Wells Fargo is committed to building community resilience to the impacts of climate change, particularly in underserved communities. Our partnership in this report with the USCM is a part of our work to support the transition to a resilient, equitable and sustainable economy.”
									</p>

								</blockquote>
								<figcaption>&ndash; <cite>Robyn Luhning, chief sustainability officer at Wells Fargo</cite></figcaption>
							</div>

							<p className="cite-link">Download the full report here: <a onClick={()=> fireTag("A1","investing in resilient and equitable neighborhoods")}  target="_blank" href="https://www.usmayors.org/wp-content/uploads/2023/01/Wells-Fargo-white-papers-011823_830pm.pdf">Investing in Resilient and Equitable Neighborhoods</a></p>
						</figure>
					</div>
				</div>

				<div className="flex-row full-width mt-10 mb-10">
					<div className="flex-row text-center">
						<div className="flex-col-md-8 flex-col-sm-12 text-center content-box">
							<div className="inner-content">
								<div className="highlighted-container">
									<p>
										USCM and Wells Fargo embarked on a year-long effort to work with local leaders on how to identify and mitigate the impacts of climate change. The collaboration brought together city leaders, subject matter experts, and non-profits to examine innovative financing mechanisms, share best practices, and outline potential solutions.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center">
						<p>
							Input from mayors and government officials is critically important. The report finds local leaders are uniquely positioned to recognize the needs of their community and the challenges of their geography. Cities across the country are experiencing the impacts of climate change. Coastal cities like Miami, New Orleans, and Charleston are dealing with rising sea levels and destructive storms, while non-coastal cities like Madison and Albuquerque are experiencing warmer temperatures and water shortages.
						</p>
						<h2 className="subhead">
							Extreme weather is increasingly costly
						</h2>
						<p>
							The <a onClick={()=> fireTag("A1","national centers for environmental information")}  target="_blank" href="https://www.ncei.noaa.gov/access/billions/" rel="noreferrer">National Centers for Environmental Information</a> says extreme weather is becoming more frequent and expensive, costing many cities billions of dollars in recovery and rebuilding efforts. According to the USCM report, those expenses can be reduced by increasing resilience and empowering communities to anticipate, accommodate, and prepare.
						</p>
						<p>
							For example, cities facing heat waves, cold spells, and other weather-related events can experience strains on electric grids. By increasing efficiency and deploying distributed solar and storage, households and businesses can be better prepared to get through challenging events.
						</p>


						<h3 className="subhead subsection-title">
							The report highlights five strategies for resilient neighborhoods:
						</h3>

						<ul className="copy-list">
							<li>
								Reimagining growth with inclusive, smart land use.
							</li>
							<li>
								Reducing dependence on cars — and increasing energy independence.
							</li>
							<li>
								Efficient, electric buildings provide a resilient shell.
							</li>
							<li>
								Flexible, local energy systems.
							</li>

							<li>
								Nature-based solutions.
							</li>
						</ul>


						<h2 className="subhead">Financial partners bolster resilient communities</h2>

						<p>
							USCM says the public and private sectors can work together to transform communities into more equitable and resilient places to live, work, and thrive. That resilience enables communities to plan for and adapt to changing conditions.
						</p>

						<figure className="pullquote mt-30 mb-30">
							<div className="bd-left">

								<blockquote cite="Miami Mayor Francis X. Suarez, USCM President">
									<p>
										“Mayors continue to be on the front lines as they deal with the consequences of the climate crisis in their own communities and push for solutions. We are proud to share this report, a blueprint to help communities as they work to become more resilient, which would not have been possible without the collaboration between mayors and business partners over the past year.”
									</p>

								</blockquote>
								<figcaption>&ndash; <cite>Miami Mayor Francis X. Suarez, USCM President</cite></figcaption>
							</div>
						</figure>


						<p>
							According to the report, the private sector, including banks and other financial institutions, needs to be part of the solution and come to the table with pragmatism, innovation, and equity to invest in and scale resilient infrastructure. By partnering with the public sector, philanthropy, community development financial institutions, and other community-based organizations, banks like Wells Fargo can provide financing options beyond what the federal government can currently offer. Some cities use public-private partnerships, general obligation bonds, revolving loan funds, performance contracting, and tax increment financing.
						</p>


						<p>
							Wells Fargo <a onClick={()=> fireTag("A1","committed to deploying $500 billion")}  target="_blank" href="https://www.wellsfargo.com/about/corporate-responsibility/environment/" rel="noreferrer">committed to deploying $500 billion</a> in sustainable financing by 2030. The new tax credit programs from the Inflation Reduction Act also engage private financing partners for clean energy, batteries, electric vehicles, building efficiency, and other technologies.
						</p>

						<p>
							Lower income, historically <a onClick={()=> fireTag("A1","disadvantaged neighborhoods and households")}  target="_blank" href="https://www.epa.gov/newsreleases/epa-report-shows-disproportionate-impacts-climate-change-socially-vulnerable" rel="noreferrer">disadvantaged neighborhoods and households</a> are typically on the frontlines of climate change. The Biden Administration’s <a onClick={()=> fireTag("A1","justice40 initiative")}  target="_blank" href="https://www.whitehouse.gov/environmentaljustice/justice40/" rel="noreferrer">Justice40 initiative</a> has made it a goal that at least 40% of the overall benefits from certain federal investments go to disadvantaged communities. By understanding their challenges, banks can deliver successful, customized solutions.
						</p>


						<p>
							City leaders are calling for an all-hands-on-deck approach to effectively combat the issue of climate change. As U.S. cities pursue resilience, they will also reduce emissions, build community wealth, and encourage more socially and economically diverse communities.
						</p>


					</div>
				</div>

				{/*<div className="keyline flex-col-md-8 flex-col-sm-12 text-center no-padding"></div>*/}
				{/*<KonamiElement className="grid"/>*/}
			</main>

			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>

			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}
			{/* Adobe retargeting tag */}
			{
				/*
					REMOVE TAG
					<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
				*/
			}
		</>
	);
};

export default withRouter(Mayors);
